import React, { useState, useEffect } from "react";
import { Link, Switch, Route, useHistory } from "react-router-dom";

import { Avatar, Dropdown, Icon, Layout, Menu, Row } from "antd";

import moment from "moment";

import UserImg from "../../../media/profile-img.jpg";
import logo from "../../../media/CosmoName.png";

import "../../dashboard/dashboard.less";
import MergeUpdateCards from "../merge-update-cards/MergeUpdateCards";
import GeneratedReport from "../generated-reports/GeneratedReports";
// import Synchronize from "../synchronize/Synchronize";
import DateComponent from "components/DateComponent/DateComponent";
import ReactCountryFlag from "react-country-flag";

const { Sider, Content } = Layout;

const PosDash = ({ ...props }) => {
	const history = useHistory();
	const [page, setPage] = useState(history.location.pathname.split("/")[1] === "" ? "merge-update-cards" : history.location.pathname.split("/")[1]);

	let username = localStorage.getItem("username");

	const handleLogout = () => {
		localStorage.clear();
		history.go(0);
	};

	useEffect(() => {
		setPage(history.location.pathname.split("/")[1] === "" ? "merge-update-cards" : history.location.pathname.split("/")[1]);
	}, [history.location.pathname]);

	return (
		<>
			<Layout>
				<div
					style={{
						position: "fixed",
						top: "0",
						right: "0",
						width: "100%",
						padding: "15px 30px",
						// background: "#FAFAFA",
						// zIndex: "10",
						// boxShadow:"0 2px rgba(0, 0, 0, 0.1)"
					}}>
					<Row type="flex" align="middle" justify="end" className="header-container">
						<DateComponent />
						<Dropdown
							overlay={
								<Menu mode="horizontal">
									<Menu.Item>
										<a onClick={handleLogout}>Logout</a>
									</Menu.Item>
								</Menu>
							}
							trigger={["click"]}>
							<a className="ant-dropdown-link" style={{ textTransform: "capitalize", fontSize: "14px" }}>
								<Avatar size={32} src={UserImg} className="margin-right-5" />
								{username} <Icon type="down" style={{ color: "#6E7191" }} />
							</a>
						</Dropdown>
					</Row>
				</div>

				<Layout>
					<Sider
						style={{
							background: "#272727",
							position: "fixed",
							top: 0,
							bottom: 0,
							overflow: "hidden",
							zIndex: 20,
							// paddingTop: 40
							// color: "#fff"
						}}
						trigger={null}
						collapsible
						// collapsed={this.state.collapsed}
						// className={this.state.collapsed ? "hide-on-small" : "overlay " + "sider"}
					>
						<div className="logo" style={{ display: "flex", alignItems: "flex-end" }}>
							<img
								src={logo}
								style={{
									height: "40px",
                                    width: "100px",
								}}
							/>
							<ReactCountryFlag
								countryCode={JSON.parse(localStorage.getItem("countryData"))?.short_name || "AE"}
								svg
								style={{
									height: "23px",
									width: "23px",
									borderRadius: "20px",
									backgroundColor: "black",
									objectFit: "cover",
									marginLeft: "5px",
									alignSelf:'center'
								}}
							/>
						</div>

						<Menu
							mode="inline"
							style={{
								backgroundColor: "#272727",
							}}
							defaultSelectedKeys={[page]}
							onSelect={({ key }) => {
								setPage(key);
								props.history.go(0);
							}}>
							<Menu.Item key="merge-update-cards">
								<Link to="/merge-update-cards">
									<div
										style={
											page === "merge-update-cards"
												? {
														background: "linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)",
														margin: "0 -16px",
														padding: "0 16px",
												  }
												: {}
										}>
										<Icon
											type="credit-card"
											style={{ fontSize: "16px", color: "rgba(255,255,255,0.8)" }}
											theme={page === "merge-update-cards" ? "filled" : "outlined"}
										/>
										<span
											style={{
												fontSize: "16px",
												color: "rgba(255,255,255,0.8)",
												lineHeight: "22px",
												fontWeight: `${page === "merge-update-cards" ? "bold" : "normal"}`,
											}}>
											Merge / Update Cards
										</span>
									</div>
								</Link>
							</Menu.Item>
							{/* <Menu.Item key="pos-report">
								<Link to="/pos-report">
									<div
										style={
											page === "pos-report"
												? {
														background: "linear-gradient(90deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)",
														margin: "0 -16px",
														padding: "0 16px",
												  }
												: {}
										}>
										<Icon
											type="credit-card"
											style={{ fontSize: "16px", color: "rgba(255,255,255,0.8)" }}
											theme={page === "merge-update-cards" ? "filled" : "outlined"}
										/>
										<span
											style={{
												fontSize: "16px",
												color: "rgba(255,255,255,0.8)",
												lineHeight: "22px",
												fontWeight: `${page === "pos-report" ? "bold" : "normal"}`,
											}}>
											POS Report
										</span>
									</div>
								</Link>
							</Menu.Item> */}
							
						</Menu>
					</Sider>

					<Content
						style={{
							// display: "flex",
							// justifyContent: "center",
							// maxWidth: "1300px",
							margin: "0 0 0 290px",
							background: "#E5E5E5",
							minHeight: "100vh",
							height: "max-content",
						}}>
						<Switch>
							<Route path="/merge-update-cards" component={MergeUpdateCards} />
							{/* <Route path="/pos-report" component={GeneratedReport} /> */}
							{/* <Route path="/synchronize" component={Synchronize} /> */}
							<Route path="/" component={MergeUpdateCards} />
							<Route
								path="*"
								component={() => (
									<Row
										type="flex"
										justify="space-between"
										align="middle"
										style={{
											width: "100%",
											padding: "40px 25px 0",
											margin: "60px auto 20px",
											backgroundColor: "#FAFAFA",
										}}>
										404 NOT FOUND nnn
									</Row>
								)}></Route>
						</Switch>
					</Content>
				</Layout>
			</Layout>
		</>
	);
};

export default PosDash;
